import { render } from "./Wheel.vue?vue&type=template&id=440a41e6&bindings={\"radius\":\"props\",\"position\":\"props\",\"items\":\"props\",\"angle\":\"setup\",\"wedges\":\"setup\",\"startSpin\":\"setup\",\"wheel\":\"setup\",\"buttonSize\":\"setup\",\"spinLabelImageObj\":\"setup\",\"wedgeElements\":\"setup\"}"
import script from "./Wheel.vue?vue&type=script&lang=js"
export * from "./Wheel.vue?vue&type=script&lang=js"
script.render = render

export default script